const screens = {
	xxsmall: "320px",
	xsmall: "480px",
	small: "600px",
	medium: "768px",
	large: "1024px",
	xlarge: "1441px",
};

const grids = {
	maxWidth: "1280px",
	largeWidth: "1080px",
	mediumWidth: "944px",
	insetWidth: "981px",
	insetWidthMedium: "740px",
	gutterWidth: "24px",
};

const Sizes = {
	screens,
	grids,
};

export default Sizes;
